<mat-card class="card mat-elevation-z0" style="overflow-x: hidden; border-bottom: 1px solid var(--primary);">
    <mat-card-content>
        <div fxLayout="row">

            <div fxLayout="column" fxFlex="80">
                <div fxLayout="row" class="cardInfo" fxLayoutAlign="start center center">

                    <div fxLayout="column" fxFlex="85" class="infoSection">

                        <div fxLayout="row" fxLayoutAlign="start center" class="titleSection">{{affirmation.title}}</div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ύπαρξη Σχολίων:</span>
                            <span class="infoDescription" fxFlex="35">{{affirmation.hasComments === 0 ? 'OXI' : 'NAI'}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δραστηριότητα</span>
                            <span class="infoDescription" fxFlex="35">{{affirmation.activityDescription}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημοσίευση σε κατηγορίες</span>
                            <span class="infoDescription" fxFlex="35">{{publishedTo}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ημ. δημιουργίας</span>
                            <span class="infoDescription" fxFlex="35">{{affirmation.created_date}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Δημιουργήθηκε/Ενημερώθηκε από:</span>
                            <span class="infoDescription" fxFlex="35">{{affirmation.first_name}} {{affirmation.last_name}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Ημ. ενημέρωσης:</span>
                            <span class="infoDescription" fxFlex="35">{{affirmation.modified_at}}</span>
                        </div>

                        <div fxLayout="row wrap" fxLayoutGap="35px" class="infoRow">
                            <span class="infoHeader" fxFlex="45">Είναι δημοσιευμένη</span>
                            <span class="infoDescription" fxFlex="35">{{affirmation.is_published === 0 ? 'OXI' : 'NAI'}}</span>
                        </div>

                    </div>
                </div>
            </div>


            <!--              Action Button-->
            <div fxLayout="column" fxLayoutAlign="center center center" fxFlex="20">
                <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" style="cursor: pointer;">
                    <div fxLayout="row" fxLayoutAlign="center center center" fxShow.gt-sm fxHide.lt-md>
                        <!--                  <label style="cursor: pointer;">Ενέργεια</label>-->
                        <button mat-flat-button
                                style="color: white; background:var(--primary); border:1px solid var(--primary); font-family: 'Century Gothic', sans-serif !important;">
                            Ενέργεια
                            <mat-icon style="vertical-align: middle; color:white;">
                                {{menuTrigger.menuOpen ? 'expand_less' : 'expand_more'}}
                            </mat-icon>
                        </button>

                    </div>

                    <div fxLayout="row" fxLayoutAlign="center center center" fxHide.gt-sm fxShow.lt-md>

                        <button mat-icon-button>
                            <mat-icon style="vertical-align: middle;">
                                more_vert
                            </mat-icon>
                        </button>

                    </div>
                </div>

                <mat-menu #menu="matMenu">
                    <mat-list>
                        <mat-list-item *ngIf="affirmation.is_published === 0" class="menuList" (click)="publishAffirmation(affirmation)">
                            <button mat-menu-item>
                                <mat-icon class="icon">publish</mat-icon>&nbsp;Δημοσίευση δήλωσης
                            </button>
                        </mat-list-item>
                        <mat-list-item *ngIf="affirmation.is_published === 1" class="menuList" (click)="cancelAffirmation(affirmation)">
                            <button mat-menu-item>
                                <mat-icon class="icon">cancel</mat-icon>&nbsp;Ακύρωση δημοσίευσης
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" (click)="showAffirmation(affirmation)">
                            <button mat-menu-item>
                                <mat-icon class="icon">visibility</mat-icon>&nbsp;Προεπισκοπηση δήλωσης
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" (click)="editAffirmation(affirmation)">
                            <button mat-menu-item>
                                <mat-icon class="icon">edit</mat-icon>&nbsp;Επεξεργασία δήλωσης
                            </button>
                        </mat-list-item>
                        <mat-list-item class="menuList" (click)="deleteAffirmation(affirmation)">
                            <button mat-menu-item>
                                <mat-icon class="icon">delete</mat-icon>&nbsp;Διαγραφή δήλωσης
                            </button>
                        </mat-list-item>
                    </mat-list>
                </mat-menu>
            </div>
        </div>
    </mat-card-content>
</mat-card>
